// extracted by mini-css-extract-plugin
module.exports = {"bird":"YI718R","button":"_1_OVrd"};